<template>
  <div class="designer-content">
    <!-- SECTIONS WRAPPER -->
    <draggable
      v-model="template.sections"
      :options="sectionInnerOptions"
      class="sections-inner-container"
      @change="onChange"
    >
      <designer-section
        v-for="(section, $index) in template.sections"
        :key="section.index"
        :section="section"
        :index="[$index]"
        @select="onSelect"
        @delete="onDelete"
        @collapse="onCollapseSection"
      >
        <draggable
          v-model="section.$children"
          :options="itemsInnerOptions"
          class="questions-inner-container"
          :move="onMoveCallback"
          @change="onChange"
        >
          <!-- CHILDRENS WRAPPER -->
          <div
            v-for="(child, $childIndex) in section.$children"
            :key="child.$id"
          >
            <designer-question
              :question.sync="child"
              :index="[$index, $childIndex]"
              @select="onSelect"
              @delete="onDelete"
              v-if="child.$group==='question'"
            />
            <designer-section
              :section="child"
              :index="[$index, $childIndex]"
              @select="onSelect"
              @delete="onDelete"
              @collapse="onCollapseSection"
              v-else
            >
              <draggable
                v-model="child.$children"
                :options="subsectionQuestionInnerOptions"
                class="subsection-questions-inner-container"
                @change="onChange"
              >
                <!-- QUESTIONS WRAPPER -->
                <designer-question
                  v-for="(question, $questionIndex) in child.$children"
                  :key="question.$id"
                  :question.sync="question"
                  :index="[$index, $childIndex,$questionIndex]"
                  @select="onSelect"
                  @delete="onDelete"
                />
                <div
                  slot="footer"
                  class="empty-template"
                  v-if="child.$group === 'subsection' && !child.$children.length"
                >
                  Sub-sección vacía
                </div>
              </draggable>
            </designer-section>
          </div>
          <div
            slot="footer"
            class="empty-template d-flex justify-content-center align-items-center"
            v-if="!section.$children.length"
          >
            Sección vacía
          </div>
        </draggable>
      </designer-section>
      <div
        slot="footer"
        class="empty-template"
        v-if="template.sections && !template.sections.length"
      >
        <h1>Evaluación vacía</h1>
        <p>Para comenzar arrastre una sección en esta área</p>
      </div>
    </draggable>
    <!-- SECTIONS END -->
  </div>

</template>

////////////////////////////
//                   SCRIPT
////////////////////////////
<script>
import Draggable from 'vuedraggable'
import DesignerQuestion from './_shared/designer-question'
import DesignerSection from './_shared/designer-section'
import DesignerSubsection from './_shared/designer-subsection'

export default {
  name: 'DesignerContent',
  components: {
    DesignerQuestion,
    DesignerSubsection,
    DesignerSection,
    Draggable
  },
  props: {
    selectedItem: {
      type: Object,
      required: false,
      default () {
        return null
      }
    },
    template: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      invalid: false,
      sectionInnerOptions: {
        handle: '.drag-handler',
        group: { name: 'section', pull: false, put: true }
      },
      questionInnerOptions: {
        handle: '.drag-handler',
        group: { name: 'question', pull: true, put: true }
      },
      itemsInnerOptions: {
        handle: '.drag-handler',
        group: {
          name: 'item',
          pull: true,
          put: ['subsection', 'question', 'item', 'subsection-question']
        }
      },
      subsectionQuestionInnerOptions: {
        handle: '.drag-handler',
        group: {
          name: 'subsection-question',
          pull: true,
          put: ['question', 'item', 'subsection-question']
        }
      }
    }
  },
  methods: {
    onCollapseSection (index) {
      this.template.sections[index].collapsed = !this.template.sections[index]
        .collapsed
    },
    onDelete (index, group) {
      this.$confirm(
        'Se eliminaran todas las subsecciones, preguntas y respuestas contenidas dentro de esta sección.',
        '¿Está seguro que desea eliminar esta seccion?'
      ).then(() => {
        if (index.length === 3) {
          return this.template.sections[index[0]].$children[index[1]].$children.splice(index[2], 1)
        } else if (index.length === 2) {
          return this.template.sections[index[0]].$children.splice(index[1], 1)
        } else {
          return this.template.sections.splice(index[0], 1)
        }
      })
    },
    onChange (e) {
      if (e.added && !e.added.element.$added) {
        e.added.element.$added = true
        e.added.element.index = e.added.newIndex
        this.onSelect(e.added.element)
      }
    },
    onMoveCallback (evt, originalEvent) {
      return (
        evt.draggedContext.element.$group !== 'subsection' ||
        evt.to.className !== 'subsection-questions-inner-container'
      )
    },
    onSelect (item) {
      this.$emit('update:selectedItem', item)
    }
  }
}
</script>

////////////////////////////
//                    STYLE
////////////////////////////
<style
  lang="scss"
  scoped
>
.designer-content {
  overflow: auto;
  height: 90vh;
  .empty-template {
    text-align: center;
    padding: 60px;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/designer/designer-content.vue